import classNames from "classnames";
import React, { useState } from "react";
import SVG from "react-inlinesvg";
import EmailSVG from "tsi-common-react/img/icons/email-sent.svg";
import Link from "tsi-common-react/src/common/Link";
import { usePageURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import { Image } from "../../../common/Image";
import { IOfferDiscount } from "../../../models/catalogue.interfaces";

import styles from "./common-full.module.scss";

export const OfferLineFull = (props: {
    offerData: IOfferDiscount;
}): React.ReactNode => {
    const [isSavingsInfoExpanded, setIsSavingsInfoExpanded] = useState(true);
    const cardURL = usePageURL("how-will-i-receive-my-card");
    const toggleAccordion = () => {
        setIsSavingsInfoExpanded((prev) => !prev);
    };
    const basketSavingsID = `voucher-line-savings-details-${props.offerData.short_name}`;
    return (
        <section className={styles.virtualLine}>
            {props.offerData.desktop_image && (
                <div className={styles.firstColumn}>
                    <Link href={cardURL} target="_top">
                        <Image
                            alt={props.offerData.short_name}
                            src={props.offerData.desktop_image}
                        />
                    </Link>
                </div>
            )}
            <div>
                <h2 className={styles.virtualTitle}>
                    <Link href={cardURL} target="_top">
                        {props.offerData.name}
                    </Link>
                </h2>
            </div>
            <div className={styles.quantity}>
                <span>
                    {/* TODO(i18n): Use t with interpolation to keep sentence together: {t`Qty: ${props.offerData.freq}`} */}
                    {t`Qty:`} &nbsp; {props.offerData.freq}
                </span>
            </div>
            <div className={styles.virtualLineSavings}>
                <div className={styles.savingSummary}>
                    <button
                        className={classNames({
                            [styles.accordionButton]: true,
                            [styles.accordionButtonExpanded]:
                                isSavingsInfoExpanded,
                        })}
                        aria-controls={basketSavingsID}
                        onClick={toggleAccordion}
                        aria-expanded={isSavingsInfoExpanded}
                    >
                        {t`Total Savings`}
                    </button>
                </div>
                {isSavingsInfoExpanded && (
                    <div className={styles.savingSummary}>
                        <div
                            id={basketSavingsID}
                            className={styles.savingDetails}
                        >
                            {props.offerData.short_name}
                        </div>
                    </div>
                )}
            </div>
            <div className={styles.whiteGloveDelivery}>
                <span className={styles.deliveryText}>
                    <SVG src={EmailSVG} />
                    {t`Gift card redemption instructions sent via email`}
                </span>
            </div>
        </section>
    );
};
